export default {"src":"/newStatic/_next/static/media/turkeyFlag.abbb5afb.svg","height":56,"width":56};